import { Moment } from 'moment';

import {
  ProviderType,
  RoomDataViewModel,
  RoomInfoViewModel,
  RoomVariationViewModel,
} from '@api/index';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { getCurrencySymbol } from '@utils/utils';
import { checkLoyaltyPreviouslyValidated } from '@components/ui/loyalty-verifications/helpers';

import { SelectedVariationProps } from '../../context/types';

type RoomParams = {
  selectedVariations: SelectedVariationProps[];
  information: RoomDataViewModel;
  detail: RoomInfoViewModel;
  variation: RoomVariationViewModel;
  hotelRoomList: ListingSearchRoomInterface[];
  startDate: Moment;
  endDate: Moment;
  hotelId: number;
  hotelName: string;
  isExpedia: boolean;
  selectedTab: number;
  nightCount: number;
};

// ===================================
// Get Room Card Params
// ===================================
export const getRoomCardProps = ({
  information,
  detail,
  selectedVariations,
  variation,
  hotelId,
  hotelName,
  hotelRoomList,
  startDate,
  endDate,
  isExpedia,
  selectedTab,
  nightCount,
}: RoomParams) => {
  return {
    roomSquareMeter: detail.roomInfo?.roomSquareMeters,
    childWithPriceCount: detail?.informations?.[0]?.childWithPriceCount,
    id: hotelId,
    key: variation.id,
    hotelName: hotelName,
    formCheckInDate: startDate,
    formCheckOutDate: endDate,
    hotelRoomList: hotelRoomList,
    title: detail.roomInfo?.boardType,
    promotionInfoName: variation.promotionInfoName,
    prices: {
      milePrice: variation.milePrice,
      originalPrice: isExpedia
        ? variation.originalTotalDiscountedSellingPrice
        : variation.totalSellingPrice,
      price: variation.totalDiscountedSellingPrice,
      currency: getCurrencySymbol(variation.currency),
      discount: variation.discountRatioText,
      originalCurrency: isExpedia
        ? getCurrencySymbol(variation.originalCurrency)
        : getCurrencySymbol(variation.currency),
    },
    isExpedia: isExpedia,
    hasCancelletion: detail.isRefundable,
    roomInformation: `${nightCount ? `${nightCount} Gece, ` : ''}${
      information.adultCount ? information.adultCount + ' Yetişkin ' : ''
    } ${
      information.childWithDiscountedPriceCount &&
      information.childWithDiscountedPriceCount > 0
        ? `${information?.childWithDiscountedPriceCount} İndirimli Çocuk, `
        : ''
    } ${
      information.childWithoutPriceCount &&
      information.childWithoutPriceCount > 0
        ? `${information?.childWithoutPriceCount} Ücretsiz Çocuk`
        : ''
    } ${
      information.childWithoutPriceCount === 0 &&
      information.childWithDiscountedPriceCount === 0 &&
      information.childCount
        ? `${information?.childCount} Çocuk`
        : ''
    }`,
    status: information.availabilityStatus,
    isSelected:
      selectedVariations.findIndex(
        (item) =>
          item.variationId === variation.id && item.tabNumber === selectedTab
      ) !== -1,
    loyalty: variation.loyaltyType
      ? {
          isActive:
            variation.isLoyaltyActivated ||
            checkLoyaltyPreviouslyValidated(variation?.loyaltyType),
          loyaltyType: variation.loyaltyType,
        }
      : undefined,

    alertMessage: information.availabilityMessage,
    cancellationPolicyDetails: detail.roomInfo?.cancellationPolicyDetails,
    feeDetails: detail.roomInfo?.expediaPriceDetail,
  };
};

// ===================================
// Get Handle Selected Variation Params
// ===================================
export const getHandleSelectedVariationParams = ({
  information,
  variation,
  selectedTab,
  detail,
  roomId: id,
  roomProvider: provider,
}: Pick<RoomParams, 'selectedTab' | 'information' | 'variation' | 'detail'> & {
  roomId: number;
  roomProvider: ProviderType | undefined;
}) => {
  return {
    tabNumber: selectedTab,
    roomId: id,
    variationId: variation.id,
    promotionInfoName: variation.promotionInfoName,
    totalDiscountedSellingPrice: variation.totalDiscountedSellingPrice || 0,
    cancelletionPolicyId: detail.roomInfo?.cancellationPolicyId || 0,
    boardTypeId: detail.roomInfo?.boardTypeId || 0,
    provider: provider,
    promotionId: variation.promotionIdList || '',
    loyaltyType: variation?.loyaltyType || null,
    guests: {
      adultCount: information.adultCount,
      childrenBirthDates: information.childrenBirthDates,
    },
    roomTypeId: detail.roomInfo?.roomTypeId,
    boardTypeName: detail.roomInfo?.boardType,
    milePrice: variation?.milePrice || 0,
  };
};
